// extracted by mini-css-extract-plugin
module.exports = {"container":"TextArea_container__1RW5i","label":"TextArea_label__3lyN-","inputbox":"TextArea_inputbox__wFISl","star":"TextArea_star__iE55e"};